import { ApolloClient, createHttpLink, InMemoryCache } from "@apollo/client";
import { split } from "@apollo/client";
import { WebSocketLink } from "@apollo/client/link/ws";
import { getMainDefinition } from "@apollo/client/utilities";
import { setContext } from "@apollo/client/link/context";
import { getAccessToken } from "./services/LocalStorage";
import { API_URL } from "./config";

const convertHttpUrlToWs = (httpUrl?: string) => {
  if (!httpUrl) return "";
  return `${httpUrl
    .trim()
    .replace("http", "ws")
    .replace(/\/$/, "")}/subscriptions`;
};
export const createClient = () => {
  const httpLink = createHttpLink({
    uri: API_URL, // URL for HTTP requests
  });

  const wsLink = new WebSocketLink({
    uri: convertHttpUrlToWs(API_URL), // Default WebSocket URL based on HTTP URL
    options: {
      reconnect: true, // Reconnect automatically
    },
  });

  const authLink = setContext(async (_, { headers }) => {
    // Get the authentication token from local storage or any other storage
    const token = await getAccessToken();
    // Return the headers to the context so httpLink and wsLink can read them
    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : "",
      },
    };
  });

  const link = split(
    // split based on operation type
    ({ query }) => {
      const definition = getMainDefinition(query);
      return (
        definition.kind === "OperationDefinition" &&
        definition.operation === "subscription"
      );
    },
    wsLink,
    authLink.concat(httpLink),
  );

  return new ApolloClient({
    link,
    cache: new InMemoryCache(),
  });
};
